// Binding handler om een afbeelding te tonen.
export class AfbeeldingBindingHandler implements KnockoutBindingHandler {
    public update(element: HTMLElement, valueAccessor: () => any) {
        element.innerHTML = "";

        let value = ko.unwrap(valueAccessor());
        if (typeof value === "string" && value.length > 0) {
            let img = document.createElement('img');
            img.src = value;
            element.appendChild(img);
        }
    }
}
